export const SegmentedControl = "atlantis-segmented-control";
export const SegmentedControlButton = "atlantis-segmented-control-button";

